import { useMemo } from "react"
import type { GraphActivity } from "./GraphActivity"

import { prioritizeBolusActivity } from "./prioritizeBolusActivity"

/*
 * sorts the graphActivities into the available space above and below the glucose readings
 */
export function useSortedGraphActivities(
  graphActivities: GraphActivity[], // sorted by descending startedAt
  rowsAboveGlucose: number,
  rowsBelowGlucose: number,
): [GraphActivity[], GraphActivity[]] {
  return useMemo(
    () => {
      const numberOfGraphActivities = graphActivities.length

      if (numberOfGraphActivities === 0) {
        return [
          [],
          [],
        ]
      }

      const topGraphActivities: GraphActivity[] = []
      const bottomGraphActivities: GraphActivity[] = []
      const availableRows = rowsAboveGlucose + rowsBelowGlucose
      const prioritizedGraphActivities = prioritizeBolusActivity(
        graphActivities,
        availableRows,
      )

      prioritizedGraphActivities.forEach((activity) => {
        const spaceRemainingTop = rowsAboveGlucose - topGraphActivities.length
        const spaceRemainingBottom =
          rowsBelowGlucose - bottomGraphActivities.length

        if (spaceRemainingTop > spaceRemainingBottom) {
          topGraphActivities.push(activity)
        } else if (spaceRemainingBottom > spaceRemainingTop) {
          bottomGraphActivities.push(activity)

        // if there is no more space remaining
        } else if (spaceRemainingTop === 0 && spaceRemainingBottom === 0) {
          // TODO handle when there is not more space available here
          // if there is equal space remaining and more space above glucose
        } else if (rowsAboveGlucose > rowsBelowGlucose) {
          bottomGraphActivities.push(activity)

          // if there is equal space remaining and more space below glucose
        } else {
          topGraphActivities.push(activity)
        }
      })

      return [
        topGraphActivities,
        bottomGraphActivities,
      ]
    },
    [
      rowsAboveGlucose,
      rowsBelowGlucose,
      graphActivities,
    ],
  )
}
